module.exports = __webpack_public_path__ + "static/media/Memb-I-00131_0003.dc64281a.jpg";